import React, {Component} from 'react'
import parse from 'html-react-parser';
import {getArticleById} from '../../../services/reservoir'
import Loading from '../Loading'
import Error404 from '../../pages/errors/404'

export default class Article extends Component {
  constructor (props) {
    super(props)

    this.state = {
      loading: true,
      content: null
    }
  }

  componentDidMount() {
    this.loadArticle()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.articleId !== this.props.match.params.articleId) {
      this.loadArticle()
    }
  }

  loadArticle = () => {
    this.setState({
      content: null,
      loading: true,
    })

    getArticleById(this.props.match.params.articleId).then(article => {
      this.setState({
        content: article && article.attributes && article.attributes.body && article.attributes.body.value,
        loading: false,
      })
    })
  }

  render() {
    if (this.state.loading) {
      return <Loading/>
    }

    if (this.state.content !== null) {
      return <div>{parse(this.state.content)}</div>
    }

    return <Error404/>
  }
}
